import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { generateClient } from 'aws-amplify/api';
import { getGameModule } from '../graphql/queries';

const client = generateClient();

const GameModuleView = () => {
  const { id } = useParams();
  const [module, setModule] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchModule();
  }, [id]);

  const fetchModule = async () => {
    try {
      const response = await client.graphql({
        query: getGameModule,
        variables: { id }
      });
      setModule(response.data.getGameModule);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!module) return <div>No module found</div>;

  return (
    <div className="game-module-view">
      <h2>{module.name}</h2>
      <p>{module.description}</p>
      {/* Add more details as needed */}
    </div>
  );
};

export default GameModuleView;